document.addEventListener('DOMContentLoaded', function() {
    const toggleButtons = document.querySelectorAll('[data-action="toggle-mobile-menu"]');
    const closeButtons = document.querySelectorAll('[data-action="close-mobile-menu"]');
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileMenuContainer = document.getElementById('mobile-menu-container');
    
    function openMenu() {
        // Show the overlay
        mobileMenu.classList.remove('opacity-0', 'pointer-events-none');
        mobileMenu.classList.add('opacity-100');
        mobileMenu.dataset.state = 'open';
        
        // Slide in the menu
        setTimeout(() => {
            mobileMenuContainer.classList.remove('-translate-x-full');
            mobileMenuContainer.classList.add('translate-x-0');
        }, 10);
        
        document.body.style.overflow = 'hidden';
    }
    
    function closeMenu() {
        // Slide out the menu
        mobileMenuContainer.classList.remove('translate-x-0');
        mobileMenuContainer.classList.add('-translate-x-full');
        
        // Hide the overlay after animation
        setTimeout(() => {
            mobileMenu.classList.remove('opacity-100');
            mobileMenu.classList.add('opacity-0', 'pointer-events-none');
            mobileMenu.dataset.state = 'closed';
            document.body.style.overflow = '';
        }, 300);
    }
    
    toggleButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (mobileMenu.dataset.state === 'closed') {
                openMenu();
                button.setAttribute('aria-expanded', 'true');
            } else {
                closeMenu();
                button.setAttribute('aria-expanded', 'false');
            }
        });
    });
    
    closeButtons.forEach(button => {
        button.addEventListener('click', () => {
            closeMenu();
            toggleButtons.forEach(toggleBtn => {
                toggleBtn.setAttribute('aria-expanded', 'false');
            });
        });
    });
    
    // Close when clicking outside the menu
    mobileMenu.addEventListener('click', (e) => {
        if (e.target === mobileMenu) {
            closeMenu();
            toggleButtons.forEach(toggleBtn => {
                toggleBtn.setAttribute('aria-expanded', 'false');
            });
        }
    });
});